import { DiModuleBuilder } from "@iot-platform/core";
import { WeatherDatasource } from "@weather/data/datasources/weather.datasource";
import { WeatherMapper } from "@weather/data/mappers/weather.mapper";
import { WeatherImplRepository } from "@weather/data/repositories/weather.impl-repository";
import type { WeatherRepository } from "@weather/domain/repositories/weather.repository";
import { WeatherGetAllUseCase } from "@weather/domain/usecases/weather-get-all.usecase";
import { WeatherSearchMobileViewmodel } from "@weather/presentation/pages/weather/mobile/search/weather-search-mobile.viewmodel";
import { WeatherPageViewmodel } from "@weather/presentation/pages/weather/weather-page.viewmodel";
import { weatherTypes } from "@weather/weather-types.di";
import { ContainerModule } from "inversify";

const webWeatherModule = new DiModuleBuilder();

webWeatherModule.registerSubModules(() => ({
    datasources: new ContainerModule(({ bind }) => {
        bind(WeatherDatasource).toSelf();
    }),
    mappers: new ContainerModule(({ bind }) => {
        bind(WeatherMapper).toSelf();
    }),
    repositories: new ContainerModule(({ bind }) => {
        bind<WeatherRepository>(weatherTypes.repositories.WeatherRepository).to(
            WeatherImplRepository,
        );
    }),
    useCases: new ContainerModule(({ bind }) => {
        bind(WeatherGetAllUseCase).toSelf();
    }),
    viewModels: new ContainerModule(({ bind }) => {
        bind(WeatherPageViewmodel).toSelf();
        bind(WeatherSearchMobileViewmodel).toSelf();
    }),
}));

webWeatherModule.registerModule();

export { webWeatherModule };
